export type ProfessionalCategory = "installer" | "retailer" | "manufacturer" | "convention" | "rep";

export interface Tool {
  id: string;
  name: string;
  description: string;
  logo: string;
  video_url?: string;
  categories: ProfessionalCategory[];
  tags: string[];
  rating: number;
  reviews: number;
  bookmarks: number;
  featured: boolean;
  pricing: string;
  visitUrl: string;
  dealUrl?: string;
  latitude?: number;
  longitude?: number;
  business_phone?: string;
  address?: string;
}

export const categories = [
  { name: "Installers", icon: "Wrench" },
  { name: "Retailers", icon: "Store" },
  { name: "Conventions", icon: "Calendar" },
  { name: "Manufacturers", icon: "Factory" },
  { name: "Sales Reps", icon: "UserCheck" },
];